import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import moment from 'moment';

import Spinner from '../../components/Widgets/spinner';
import { DatePicker } from '../Common/datePicker';
import { SelectionWithProps } from '../Common/selection';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import RowLabelField from '../Common/RowLabelField';
import { UI_HEIGHT } from '../Common/constants';
import { toFromDates } from '../Common/cleanDates';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import genericRadioFilter from '../Common/genericRadioFilter';
import GenericSelection from '../Common/GenericSelection';
import GenericDatePicker from '../Common/GenericDatePicker';

import { ROOT_URL, companyCodeTitle } from '../../actions/root_url';

const getBsStyle = (input, value) => {
  return input === value ? 'success' : 'primary';
};

class MobileCustomerStatement extends Component {
  static getQuarter() {
    return Math.ceil((new Date().getMonth() + 1) / 3);
  }
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,
      statementLines: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      invoiceAmount: 0,
      receiveAmount: 0,
      orderAmount: 0,
      totalOrders: 0,
      totalCaptured: 0,
      totalInvoices: 0,
      yearChanged: false,
      // fromDate: new Date('2017-08-18T00:00:00-0700'),
      fromDate: new Date(),
      toDate: new Date(),
      typeRadios: 'range',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      quarter: MobileCustomerStatement.getQuarter(),
    };

    this.setToDate = this.setToDate.bind(this);
    this.setFromDate = this.setFromDate.bind(this);
    this.formatFetchYear = this.formatFetchYear.bind(this);
    this.formatFetchMonth = this.formatFetchMonth.bind(this);
    this.formatFetchQuarter = this.formatFetchQuarter.bind(this);
    this.handleDateFilterChange = this.handleDateFilterChange.bind(this);
    this.setYearSelected = this.setYearSelected.bind(this);
    this.setMonthSelected = this.setMonthSelected.bind(this);
    this.setQuarterSelected = this.setQuarterSelected.bind(this);
  }

  componentWillMount() {
    // this.props.setDefaultOfForm('typeRadios', 'range', 'mobileCustomerStatement');
    // this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'mobileCustomerStatement');
    // this.props.setDefaultOfForm('ToDate', new Date(), 'mobileCustomerStatement');
    let date = new Date();
    this.state.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.state.toDate = new Date(date.getFullYear(), date.getMonth(), this.daysInMonth(date.getMonth()+1, date.getFullYear()));
    this.fetchCustomerStatement();
  }

  componentDidMount() {
    document.title = companyCodeTitle;
  }

  componentWillReceiveProps(nextProps) {
    const { mobileCustomerStatement, typeRadios } = this.props;

    if (mobileCustomerStatement !== nextProps.mobileCustomerStatement) {
      this.setState({
        ...nextProps.mobileCustomerStatement,
        statementLines: {
          rows: nextProps.mobileCustomerStatement.rows,
        },
      });
    }

    if (typeRadios !== nextProps.typeRadios) {
      this.props.resetMobileCustomerStatement();
      this.resetDates();
    }
  }

  setYearSelected(e) {
    this.setState({ year: e.value }, this.formatFetchYear);
  }

  setMonthSelected(e) {
    this.setState({ month: e.value }, this.formatFetchMonth);
  }

  setQuarterSelected(e) {
    this.setState({ quarter: e.value }, this.formatFetchQuarter);
  }

  setToDate(e) {
    if (e < this.state.fromDate) {
      return;
    }
    this.setState(
      { toDate: e },
      () => { this.fetchCustomerStatement(); },
    );
  }

  setFromDate(e) {
    if (e > this.state.toDate) {
      return;
    }
    this.setState(
      { fromDate: e },
      () => { this.fetchCustomerStatement(); },
    );
  }

  getYearOptions() {
    const yearOptions = [];
    let year = (new Date().getFullYear() + 1);
    while (year > 2017) {
      year -= 1;
      yearOptions.push({ value: year, label: year });
    }
    return yearOptions;
  }

  getMonthOptions() {
    const { year } = this.state;
    const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthOptions = [];
    const currentyear = new Date().getFullYear();
    let month = 0;
    if (year) {
      if (year < currentyear) {
        month = 12;
      } else {
        month = new Date().getMonth() + 1;
      }
      for (let i = 1; i < month + 1; i += 1) {
        monthOptions.push({ value: i, label: dateMap[i - 1] });
      }
    }
    return monthOptions;
  }

  getQuarterOptions() {
    const { year } = this.state;
    const quarterOptions = [];
    const currentyear = new Date().getFullYear();
    let quarter = 0;
    if (year) {
      if (year < currentyear) {
        quarter = 4;
      } else {
        const month = new Date().getMonth() + 1;
        quarter = (Math.ceil(month / 3));
      }
    }
    for (let i = 1; i < quarter + 1; i += 1) {
      quarterOptions.push({ value: i, label: i });
    }
    return quarterOptions;
  }

  formatFetchYear() {
    const { SalesType, typeRadios, year } = this.state;
    const FromDate = `${year}-01-01`;
    const ToDate = `${year}-12-31`;
    const dates = toFromDates(-1, FromDate, ToDate);
    this.setState({
      fromDate: dates.fromDate, toDate: dates.toDate, SalesType, typeRadios,
    }, this.fetchCustomerStatement);
  }

  formatFetchMonth() {
    const {
      year, month, SalesType, typeRadios,
    } = this.state;
    let FromDate = moment([year, month - 1]);
    let ToDate = moment(FromDate).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, SalesType, typeRadios,
    }, this.fetchCustomerStatement);
  }

  formatFetchQuarter() {
    const {
      year, quarter, SalesType, typeRadios,
    } = this.state;
    let FromDate = moment([year, (quarter - 1) * 3]);
    let ToDate = moment([year, (quarter * 3) - 1]).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, SalesType, typeRadios,
    }, this.fetchCustomerStatement);
  }

  daysInMonth (month, year) { 
    return new Date(year, month, 0).getDate(); 
  } 

  handleDateFilterChange(type) {
    let date = new Date();
    if (type === 'year') {
      this.setState({ typeRadios: type, year: new Date().getFullYear() }, this.formatFetchYear);
    } else if (type === 'month') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
    } else if (type === 'quarter') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: MobileCustomerStatement.getQuarter() }, this.formatFetchQuarter);
    } else if (type === 'range' && type !== this.state.typeRadios) {
      this.setState({ typeRadios: type, fromDate: new Date(date.getFullYear(), date.getMonth(), 1), toDate: new Date(date.getFullYear(), date.getMonth(), this.daysInMonth(date.getMonth()+1, date.getFullYear())) }, this.fetchCustomerStatement);
    }
  }

  // handleSelectionOnChange = (event) => {
  //   if (event) {
  //     const data = (() => {
  //       const { Year, Quarter, Month, FromDate, ToDate, typeRadios } = this.props;
  //       return { Year, Quarter, Month, FromDate, ToDate, typeRadios };
  //     })();
  //     const { fromDate, toDate } = getFromToDatesWithFilter({ ...data, [event.name]: event.value });
  //     this.props.fetchMobileCustomerStatement({ fromDate, toDate }, typeRadios);
  //   }
  // }

  fetchCustomerStatement() {
    const {
      fromDate, toDate, typeRadios,
    } = this.state;
    // const { fromDate, toDate } = getFromToDatesWithFilter({
    //   Year, Month, Quarter, FromDate, ToDate,
    // });
    this.props.fetchMobileCustomerStatement({ fromDate, toDate }, typeRadios);
  }

  resetDates() {
    this.props.setValue('mobileCustomerStatement', 'Year', '');
    this.props.setValue('mobileCustomerStatement', 'Month', '');
    this.props.setValue('mobileCustomerStatement', 'Quarter', '');
  }

  renderDateSelector() {
    const yearOptions = this.getYearOptions();
    if (this.state.typeRadios === 'range') {
      return (
        <Col xs={12}>
          <div className="report-table-filters" id="mobile-customer-statement-date-selector">
            <label className="from-label">
              <Translate value="from" />
            </label>
            {
              GenericDatePicker({
                setDate: this.setFromDate,
                selectedDate: this.state.fromDate,
              })
            }
            <label className="to-label">
              <Translate value="to" />
            </label>
            {
              GenericDatePicker({
                setDate: this.setToDate,
                selectedDate: this.state.toDate,
              })
            }
          </div>
        </Col>
      );
    } else if (this.state.typeRadios === 'month') {
      const monthOptions = this.getMonthOptions();
      return (
        <Col xs={12}>
          <div className="report-table-filters" id="mobile-customer-statement-date-selector">
            {
              GenericSelection({
                translation: <Translate value="year" />,
                options: yearOptions,
                value: this.state.year,
                setSelected: (e) => { this.setState({ year: e.value }); },
              })
            }
            {
              GenericSelection({
                translation: <Translate value="month" />,
                options: monthOptions,
                value: this.state.month,
                setSelected: this.setMonthSelected,
              })
            }
          </div>
        </Col>
      );
    } else if (this.state.typeRadios === 'quarter') {
      const quarterOptions = this.getQuarterOptions();
      return (
        <Col xs={12}>
          <div className="report-table-filters" id="mobile-customer-statement-date-selector">
            {
              GenericSelection({
                translation: <Translate value="year" />,
                options: yearOptions,
                value: this.state.year,
                setSelected: (e) => { this.setState({ year: e.value }); },
              })
            }
            {
              GenericSelection({
                translation: <Translate value="quarter" />,
                options: quarterOptions,
                value: this.state.quarter,
                setSelected: this.setQuarterSelected,
              })
            }
          </div>
        </Col>
      );
    }
    return (
      <Col xs={12}>
          <div className="report-table-filters" id="mobile-customer-statement-date-selector">
            {
              GenericSelection({
                translation: <Translate value="year" />,
                options: yearOptions,
                value: this.state.year,
                setSelected: this.setYearSelected,
              })
            }
          </div>
      </Col>
    );
  }

  renderAmountDetail() {
    const {
      invoiceAmount,
      receiveAmount,
      orderAmount,
      totalOrders,
      totalInvoices,
      totalCaptured,
    } = this.state;

    return (
      <ContentWrapper>
        <Col xs={3} id='mso-amount-details'>
          {/* renderprevious() */}
          <RowLabelField
            translation='total_order_amount:'
            value={`$${numberWithCommas(orderAmount)}` || 0}
          />
          <RowLabelField
            translation='total_invoice_amount:'
            value={`$${numberWithCommas(invoiceAmount)}` || 0}
          />
          <RowLabelField
            translation='total_received_amount:'
            value={`$${numberWithCommas(receiveAmount)}` || 0}
          />
        </Col>
        <Col xs={2} id='mso-order-details'>
          <RowLabelField
            translation='total_orders:'
            value={`${totalOrders}`}
          />
          <RowLabelField
            translation='total_invoices:'
            value={`${totalInvoices}`}
          />
          <RowLabelField
            translation='total_paid_orders:'
            value={`${totalCaptured}`}
          />
        </Col>
      </ContentWrapper>
    );
  }

  renderTable() {
    const {
      mobileCustomerStatement: {
        mobileCustomerStatementIsLoading,
        mobileCustomerStatementError,
      },
    } = this.props;
    const { typeRadios } = this.state;
    if (mobileCustomerStatementIsLoading && !mobileCustomerStatementError) {
      return (
        <div id='spinner'>
          <Spinner />
        </div>
      );
    } else if (mobileCustomerStatementError) {
      return (
       <ContentWrapper>
         <div className='alert alert-danger'>
           <label>Oops... Something Unexpected Happend.</label>
         </div>
       </ContentWrapper>
     );
    }
    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 930) ? 510 : 510;

    const getRows = () => {
        return Data.Selectors.getRows(this.state.statementLines);
    };

    const getSize = () => {
        return getRows().length;
    };

    const rowGetter = rowIdx => {
        const rows = getRows();
        return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
        const lines = Object.assign({}, this.state.statementLines, { sortColumn, sortDirection });
        this.setState({ statementLines: lines });
    };

    const firstCol = () => {
      if (typeRadios === 'year' || typeRadios === 'quarter') {
        return [{
            key: 'month',
            name: <Translate value="month" />,
            resizable: true,
            sortable: true,
            width: 80,
        }];
      }
      return [{
          key: 'day',
          name: <Translate value="date" />,
          resizable: true,
          sortable: true,
          width: 80,
      }];
    };

    // Column difinition
    const columns = firstCol().concat([
      {
          key: 'order_amount',
          name: <Translate value="order_amount" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: CashFormatter,
      },
      {
          key: 'invoice_amount',
          name: <Translate value="invoice_amount" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: CashFormatter,
      },
      {
          key: 'receive_amount',
          name: <Translate value="receive_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: CashFormatter,
      },
      {
          key: 'total_order',
          name: <Translate value="#_orders" />,
          resizable: true,
          sortable: true,
          width: 80,
      },
      {
          key: 'total_invoice',
          name: <Translate value="#_invoices" />,
          resizable: true,
          sortable: true,
          width: 80,
      },
      {
          key: 'total_capture',
          name: <Translate value="#_paid_orders" />,
          resizable: true,
          sortable: true,
          width: 120,
      },
    ]);

    //React Table Purchase Order Full Table
    return (
      <Row>
        <Col sm={12}>
          <div className='react-table-ar-ap-customer-list-statement' id="MobileCustomerStatement-dataGrid1">
            <ReactDataGrid
                onGridSort={handleGridSort}
                columns={columns}
                headerRowHeight={45}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={tableHeight}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const {
      fromDate, toDate, typeRadios,
    } = this.state;
    // const { fromDate, toDate } = getFromToDatesWithFilter({ Year, Month, Quarter, FromDate, ToDate });
    const params = `type=${typeRadios}&start_date=${fromDate}&end_date=${toDate}`;

    const printUrl = `${ROOT_URL}v1/ar/statement/mobile/print/?${params}&Bearer=${localStorage.getItem('token')}`;
    const excelUrl = `${ROOT_URL}v1/ar/statement/mobile/excel/?${params}&Bearer=${localStorage.getItem('token')}`;

    return (

      <ContentWrapper>

        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active='true'>
            <Translate value="mobile_customer_statement" />
          </Breadcrumb.Item>
        </Breadcrumb>

        <ButtonToolbar>
          <Button
            bsStyle='primary'
            href={printUrl}
            disabled
          >
            <em className='fa fa-print' />
            <Translate value="print" />
          </Button>
          <Button
            bsStyle='success'
            href={excelUrl}
            disabled
          >
            <em className='fa fa-download' />
            <Translate value="excel" />
          </Button>
        </ButtonToolbar>

        <Grid id='mobile-customer-statement'>
          {/* Date Range Pickers */}
          <Panel id='date-range-picker' className='form-horizontal'>
            <Row>
              <Col xs={7}>
                <Col xs={2}>
                  <h3 className="text-right"><Translate value="statement_range" /><span className="colon">:</span></h3>
                </Col>
                <div id='status-filter-radios'>
                  {
                    genericRadioFilter({
                      content: [
                        {
                            option: 'range',
                            id: 'dateRange-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'date_range',
                        },
                        {
                            option: 'year',
                            id: 'year-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'year',
                        },
                        {
                            option: 'quarter',
                            id: 'quarter-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'quarter',
                        },
                        {
                            option: 'month',
                            id: 'month-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'month',
                        },
                      ],
                      value: this.state.typeRadios,
                      handleOnClick: this.handleDateFilterChange,
                      type: 'buttons',
                    })
                  }
                </div>
                { this.renderDateSelector() }
              </Col>
              { this.renderAmountDetail() }
              <Col xs={12}>
                <h3 className="date-title"><Translate value={moment().format('YYYY-MM-DD')} /></h3>
              </Col>
            </Row>
          </Panel>

          <Panel className='position-relative table-collapse-fix mb0'>
            {/* Render Table  */}
            { this.renderTable() }
          </Panel>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default MobileCustomerStatement;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/mobileCustomerStatement.jsx